import React from 'react';
import {Input, InputContainer} from "finform";
import {Plus, TagText} from "#app/pages/IncomeAndExpenses/components/BaseOperationList/style";

const FilterDescriptionInput = ({
                                    showFilterDesc,
                                    setShowFilterDesc,
                                    filterDesc,
                                    setFilterDesc
                                }) => {
    return (
        <>
            {showFilterDesc ? (
                <InputContainer style={{
                    width: '120px',
                    height: '24px',
                    borderRadius: '8px',
                    background: '#fff',
                    minHeight: '48px',
                    lineHeight: '24px',
                    fontSize: '14px',
                }}>
                    <Input
                        style={{
                            padding: '0 8px',
                            marginTop: '0',
                            height: '28px',
                            lineHeight: '28px'
                        }}
                        value={filterDesc}
                        onChange={setFilterDesc}
                        onBlur={() => setShowFilterDesc(false)}
                        icon={false}
                    />
                </InputContainer>
            ) : filterDesc ? (
                <TagText onClick={() => setShowFilterDesc(true)}>
                    {filterDesc.length > 20
                        ? `${filterDesc.substr(0, 19)}...`
                        : filterDesc}
                </TagText>
            ) : (
                <Plus onClick={() => setShowFilterDesc(true)}/>
            )}
        </>
    );
};

export default FilterDescriptionInput;